import { ApplicationRef, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import { MessageBoxComponent } from '../../comp/message-box/message-box.component';
import { MessageBoxOption } from '../../models/message-box/message-box-option';

@Injectable({
  providedIn: 'root'
})
export class MessageBoxService {

  private componentRef!: ComponentRef<MessageBoxComponent>;

  private resolveFn: any = null;
  private rejectFn: any = null;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {
    this.createPopup();
  }

  private createPopup() {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(MessageBoxComponent);
    const componentRef = componentFactory.create(this.injector);
    this.appRef.attachView(componentRef.hostView);
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
    this.componentRef = componentRef;
  }



  showMessage(title: string, message: string, options: Array<MessageBoxOption>): Promise<MessageBoxOption> {
    return new Promise<{ id: string, text: string }>((resolve, reject) => {
      this.resolveFn = resolve;
      this.rejectFn = reject;

      this.componentRef
        .instance
        .showMessage(title, message, options)
        .then(option => {
          resolve(option);
        }).catch(error => reject(error));
    });
  }
}
